import { z } from 'zod';

import { ActivityLogVisibleFor } from 'src/api';

import { FormField } from './constants';
import { FormValues, FormValuesPlatformStaff } from './types';

export const formValidationSchema = z.object({
  [FormField.comment]: z
    .string('You should provide the comment')
    .trim()
    .max(1000, 'The comment must not contain more than 1000 symbols'),
  [FormField.files]: z.array(z.object({ id: z.string(), size: z.int() })).max(1),
}) satisfies z.ZodType<FormValues>;

export const formValidationSchemaPlatformStaff = formValidationSchema.extend({
  [FormField.visibleFor]: z
    .array(z.enum(ActivityLogVisibleFor), 'You should select at least one option')
    .min(1, 'You should select at least one option'),
}) satisfies z.ZodType<FormValuesPlatformStaff>;
